<template>
  <div :class="{activity_box:true, show_operate:isShowSignUp||isShowUpload||isShowEntries}" v-if="!!activity">
    <div class="activity_detail_box">
      <div class="activity_pic">
        <img :src="activity.pictureUrl" alt="" v-if="!!activity.pictureUrl && activity.pictureUrl.length > 0" />
        <img :src="require('@/assets/images/default_pic_16_9.png')" alt="" v-else />
        <!-- <span class="activity_rule_tip">活动规则</span> -->
      </div>
      <div class="activity_title" v-text="activity.activityName"></div>
      <div class="activity_comp">
        <span class="part_num">
          <Icon iconClass="users" />已有<span v-text="activity.participantsNumber" v-if="activity.status == 2||activity.status == 3"></span><span v-else>0</span>人参加
        </span>
        <span class="activity_status ongoing" v-if="activity.status == 2">进行中</span>
        <span class="activity_status over" v-else-if="activity.status == 3">已结束</span>
        <span class="activity_status not_start" v-else>即将开始</span>
      </div>
      <div class="activity_time">
        <div class="time">
          <Icon iconClass="time" />
          <span class="start_time" v-text="startTime"></span>
          <span>-</span>
          <span class="end_time" v-text="endTime"></span>
        </div>
      </div>
      <div class="location" v-if="!!activity.address">
        <Icon iconClass="locate" /><span v-text="activity.address"></span>
      </div>
    </div>
    <div class="activity_organ_box" v-if="
      (!!activity.sponsorUrlList && activity.sponsorUrlList.length > 0)
      && (!!activity.organizers && activity.organizers.length > 0 )
      && (!!activity.backers && activity.backers.length > 0)">
      <div class="sponsors_box" v-if="!!activity.sponsorUrlList && activity.sponsorUrlList.length > 0">
        <div class="sponsors_title">
          <Icon iconClass="sponsor" />主办方
        </div>
        <ul class="sponsors_list">
          <li class="sponsor_item" v-for="(sponsor, index) in activity.sponsorUrlList" :key="index" @click="toSponsor(sponsor)">
            <div class="thumbnail">
              <img :src="sponsor.sponsorThumbnail" v-if="
                  !!sponsor.sponsorThumbnail &&
                  sponsor.sponsorThumbnail.length > 0
                " />
              <img :src="
                  require('@/assets/images/activity/sponsors_thumbnail.png')
                " v-else />
            </div>
            <div class="name" v-text="sponsor.sponsorName"></div>
          </li>
        </ul>
      </div>
      <div :class="{
          organizers_box: true,
          borderTop: activity.sponsorUrlList.length > 0,
        }" v-if="!!activity.organizers && activity.organizers.length > 0">
        <div class="organizers_title">
          <Icon iconClass="organizer" />承办方
        </div>
        <ul class="organizers_list">
          <li class="organizer_item" v-for="(organizer, index) in activity.organizers" :key="index" @click="toOrganizer(organizer)">
            <div class="thumbnail">
              <img :src="organizer.organizerThumbnail" v-if="
                  !!organizer.organizerThumbnail &&
                  organizer.organizerThumbnail.length > 0
                " />
              <img :src="
                  require('@/assets/images/activity/organizers_thumbnail.png')
                " v-else />
            </div>
            <div class="name" v-text="organizer.organizerName"></div>
          </li>
        </ul>
      </div>
      <div :class="{
          backers_box: true,
          borderTop:
            activity.sponsorUrlList.length > 0 ||
            activity.organizers.length > 0,
        }" v-if="!!activity.backers && activity.backers.length > 0">
        <div class="backers_title">
          <Icon iconClass="backer" />赞助商
        </div>
        <ul class="backers_list">
          <li class="backer_item" v-for="(backer, index) in activity.backers" :key="index" @click="toBacker(backer)">
            <div class="thumbnail">
              <img :src="backer.backerThumbnail" v-if="
                  !!backer.backerThumbnail && backer.backerThumbnail.length > 0
                " />
              <img :src="require('@/assets/images/activity/backers_thumbnail.png')" v-else />
            </div>
            <div class="name" v-text="backer.backerName"></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="activity_description_box" v-if="activity.description.length>0">
      <div class="description_title">活动简介</div>
      <div class="description_cont" v-text="activity.description"></div>
    </div>
    <div class="activity_description_box" v-if="activity.activityDetail.length>0">
      <div class="description_title">活动规则</div>
      <div class="description_cont" v-html="activity.activityDetail"></div>
    </div>
    <div class="operate_box" v-if="isShowSignUp||isShowUpload||isShowEntries">
      <span class="operate_btn" v-if="isShowSignUp" @click="toSignUp">我要报名</span>
      <span class="operate_btn" v-else-if="isShowUpload && activity.id==115" @click="toSubmitWorks">上传图片/视频</span>
      <span class="operate_btn" v-else-if="isShowUpload" @click="toSubmitWorks">上传作品</span>
      <span class="operate_btn" @click="toEntries" v-if="isShowEntries">参赛作品</span>
    </div>
    <div class="operate_box" v-if="!activity.supportVote && !!applyStatus && (applyStatus.isApply == true || applyStatus.isApply == 1)">
      <span class="operate_btn operate_btn_disabled" v-if="applyStatus.checkStatus == 0">已报名（待审核）</span>
      <span class="operate_btn operate_btn_disabled" v-if="applyStatus.checkStatus == 1">已报名（审核通过）</span>
    </div>
    <div class="activity_relation_box">
      <div class="related_item raffle" v-if="activity.status==2 && showRaffle">
        <span @click="toRaffleDetail"></span>
      </div>
      <div class="related_item live" v-if="activity.status==2 && showLive">
        <span @click="toLiveDetail"></span>
      </div>
      <div class="related_item vote" v-if="activity.status==2 && showVote">
        <span @click="toVoteDetail"></span>
      </div>
      <div class="related_item my_works" v-if="isShowUpload">
        <span @click="toMyEntries"></span>
      </div>
      <!-- <div class="related_item role" v-if="isShowUpload">
        <span @click="toSubmitWorks"></span>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
import activityApi from "@/api/apis/activity.js";
export default {
  name: "activityTemplate",
  props: {
    activityInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activity: null, //活动详情
      applyStatus: null, // 会员报名状态
      raffleId: 0, // 抽奖Id
      isSignIn: false, //签到
    };
  },
  computed: {
    ...mapState("app", ["userInfo"]),
    startTime: function () {
      return this.activity.startTime.replace(/-/g, "/").slice(0, 16);
    },
    endTime: function () {
      return this.activity.endTime.replace(/-/g, "/").slice(0, 16);
    },
    /* 是否显示报名按钮 */
    isShowSignUp: function () {
      /* 活动未开始和活动进行中，才有可能报名 */
      /* 报名方式:1.线上报名;2.线下报名;3:线上+线下 */
      if (
        (this.activity.status == 1 || this.activity.status == 2) &&
        (this.activity.applyType == 1 || this.activity.applyType == 3)
      ) {
        /* 是否支持报名，报名是否有效 */
        if (this.activity.isSupportApply && this.activity.isApplyValid) {
          /* 是否已登录 */
          if (!!this.userInfo) {
            if (!!this.applyStatus) {
              // 活动名额是否已满
              if (
                this.applyStatus.timesOver == true ||
                this.applyStatus.timesOver == 1
              ) {
                return false; // 本次活动名额已满
              } else {
                // isApply 是否已报名
                if (
                  this.applyStatus.isApply == true ||
                  this.applyStatus.isApply == 1
                ) {
                  if (this.applyStatus.checkStatus == 0) {
                    // 报名未审核
                    return false;
                  } else if (this.applyStatus.checkStatus == 1) {
                    // 报名审核通过
                    return false;
                  } else if (this.applyStatus.checkStatus == 2) {
                    // 报名未审核通过，重新报名
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return true; // 未报名
                }
              }
            } else {
              return false; // 登录之后，未获取到会员报名状态时
            }
          } else {
            return true; // 未登录状态直接显示报名按钮，点击之后先登录
          }
        } else {
          return false; // 不支持报名或报名无效
        }
      } else {
        return false; // 活动结束 或 是线下报名
      }
    },
    /* 是否显示上传作品 */
    isShowUpload: function () {
      // 活动进行中才会显示
      // activity.supportVote 这个字段代表是否支持评选
      if ((this.activity.status == 1 || this.activity.status == 2) && this.activity.supportVote) {
        /* 是否已登录 */
        if (!!this.userInfo) {
          if (!!this.applyStatus) {
            // 已报名,且审核通过
            if ((this.applyStatus.isApply == true || this.applyStatus.isApply == 1) && this.applyStatus.checkStatus == 1) {
              return true;
            } else {
              false;
            }
          } else {
            return false; //登录之后，未获取到会员报名状态时
          }
        } else {
          return true; //未登录状态直接显示作品上传按钮，点击之后先登录
        }
      } else {
        return false; // 活动未开始或已结束
      }
    },
    /* 是否显示 参赛作品 */
    isShowEntries: function () {
      if(this.activity.id==115){
        return false;
      }else{
        return this.activity.supportVote; // activity.supportVote 这个字段代表是否支持评选
      }      
    },
    /* 是否关联抽奖 */
    showRaffle: function () {
      if (!!this.activity && !!this.activity.raffleId && this.activity.raffleId > 0) {
        this.raffleId = this.activity.raffleId;
        return true;
      } else if (!!this.activity && !!this.activity.relatedSignedRaffleId && this.activity.relatedSignedRaffleId > 0) {
        // 用于现场抽奖，需要先签到
        this.raffleId = this.activity.relatedSignedRaffleId;
        if (this.isSignIn == true) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    /* 是否关联直播 */
    showLive: function () {
      if (
        !!this.activity &&
        !!this.activity.liveRoomId &&
        this.activity.liveRoomId.length > 0 &&
        this.activity.liveRoomId != "0"
      ) {
        return true;
      } else {
        return false;
      }
    },
    /* 是否关联投票 */
    showVote: function () {
      if (
        !!this.activity &&
        !!this.activity.vote &&
        this.activity.vote.voteId != 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  activityInfo: {
    handler(newValue, oldValue) {
      this.activity = deepClone(newValue);
    },
    deep: true,
  },
  components: {},
  methods: {
    /* 跳转主办方详情 */
    toSponsor(item) {
      if (!!item && !!item.sponsorURL && item.sponsorURL.length > 0) {
        window.open(item.sponsorURL, "_self");
      }
    },
    /* 跳转承办方详情 */
    toOrganizer(item) {
      if (!!item && !!item.organizerURL && item.organizerURL.length > 0) {
        window.open(item.organizerURL, "_self");
      }
    },
    /* 跳转赞助商详情 */
    toBacker(item) {
      if (!!item && !!item.backerURL && item.backerURL.length > 0) {
        window.open(item.backerURL, "_self");
      }
    },
    /* 跳转报名页面 */
    toSignUp() {
      if(this.activity.id == 162){
        window.open('http://kc.ctdsb.net/cms/d/jimudianyingzhiyue/post.html',"_self")
      }else if(this.activity.id == 163){
        window.open('http://kc.ctdsb.net/cms/d/yinyuejuguanju/post.html',"_self")
      }else{
        if (!!this.userInfo) {
          this.$router.push({
            path: "/sign_up",
            query: {
              activityId: this.activity.id,
            },
          });
        } else {
          this.$router.push("/login");
        }
      }
    },
    /* 跳转参赛作品 */
    toEntries() {
      this.$router.push({
        path: "/entries",
        query: {
          activityId: this.activity.id,
        },
      });
    },
    /* 跳转抽奖 */
    toRaffleDetail() {
      this.$router.push({
        path: "/raffle_detail",
        query: {
          contentType: 2,
          freeFlag: 1,
          drawRaffleId: this.raffleId,
          type: 0,
        },
      });
    },
    /* 跳转直播 */
    toLiveDetail() {
      this.$router.push({
        path: "/live_detail",
        query: {
          contentType: 4,
          id: parseInt(this.activity.liveRoomId),
        },
      });
    },
    /* 跳转投票 */
    toVoteDetail() {
      if (!!this.userInfo) {
        this.$router.push({
          path: "/vote_detail",
          query: {
            contentType: 3,
            id: this.activity.vote.voteId,
          }
        });
      } else {
        this.$router.push("/login");
      }
    },
    /* 跳转我的作品 */
    toMyEntries() {
      if (!!this.userInfo) {
        this.$router.push({
          path: "/my_entries",
          query: {
            activityId: this.activity.id,
          },
        });
      } else {
        this.$router.push("/login");
      }
    },
    /* 跳转上传作品、我要投稿 */
    toSubmitWorks() {
      if (!!this.userInfo) {
        this.$router.push({
          path: "/submit_works",
          query: {
            activityId: this.activity.id,
          },
        });
      } else {
        this.$router.push("/login");
      }
    },
    /* 获取会员的报名状况 */
    getApplyStatus() {
      var _this = this;

      var params = {
        activityId: _this.activity.id,
        memberId: _this.userInfo.id,
      };

      activityApi
        .getApplyStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.applyStatus = res.data;
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取签到状态，用于现场报名抽奖 */
    getSignInStatus() {
      var _this = this;

      var params = {
        activityId: _this.activity.id,
        memberId: _this.userInfo.id,
      };

      activityApi
        .isSignIn(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isSignIn = res.data.isSignIn;
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    this.activity = deepClone(this.activityInfo);
    if (!!this.userInfo) {
      this.getApplyStatus(); // 当活动支持报名时，获取会员的报名状态
      this.getSignInStatus(); // 获取签到状态，用于现场报名抽奖
    }
  },
};
</script>
<style scoped lang="scss">
.activity_box {
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: #f6f6f6;
  overflow-x: hidden;
  overflow-y: auto;
  &.show_operate {
    height: calc(100% - 50px);
  }
  .activity_detail_box {
    padding: 15px;
    background-color: #fff;
    background-image: url(~@/assets/images/activity/bg.png);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;
    .activity_pic {
      position: relative;
      img {
        display: block;
        width: 100%;
        border-radius: 5px;
        -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
      }
      .activity_rule_tip {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 3px 8px;
        color: #fff;
        font-size: 12px;
        background-color: rgba(0, 0, 0, 0.3);
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
    .activity_title {
      width: 100%;
      padding: 15px 0 10px;
      line-height: 28px;
      font-size: 18px;
      font-weight: bold;
    }
    .activity_comp {
      line-height: 20px;
      padding: 0 0 10px;
      .part_num {
        color: #a6a6a6;
        font-size: 12px;
        .tj-svg-icon {
          margin-right: 5px;
          font-size: 18px;
        }
      }
      .activity_status {
        float: right;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 5px;
        font-size: 12px;
        color: #fff;
        &.ongoing {
          background: #e43732;
        }
        &.over {
          background: rgba(0, 0, 0, 0.5);
        }
        &.not_start {
          background: #00a250;
        }
      }
    }
    .activity_time {
      line-height: 24px;
      padding: 5px 0;
      .time {
        .tj-svg-icon {
          color: #a6a6a6;
          margin-right: 5px;
          font-size: 18px;
        }
        span {
          color: #666;
        }
      }
    }
    .location {
      line-height: 24px;
      padding-top: 5px;
      .tj-svg-icon {
        color: #a6a6a6;
        margin-right: 5px;
        font-size: 18px;
      }
      span {
        color: #666;
      }
    }
  }
  .activity_organ_box {
    font-family: "SimHei";
    padding: 10px 15px;
    margin: 15px;
    background-color: #fff;
    border-radius: 8px;
    .sponsors_box {
      .sponsors_title {
        height: 30px;
        line-height: 30px;
        color: #999;
        .tj-svg-icon {
          color: #999;
          margin-right: 5px;
          font-size: 20px;
          vertical-align: -0.2em;
        }
      }
      .sponsors_list {
        .sponsor_item {
          display: flex;
          padding-top: 8px;
          padding-bottom: 8px;
          border-bottom: 1px solid #ececec;
          .thumbnail {
            width: 32px;
            height: 32px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .name {
            flex: 1;
            line-height: 32px;
            margin-left: 8px;
            color: #333;
            font-size: 14px;
          }
        }
        li:last-of-type {
          border: none;
        }
      }
    }
    .organizers_box {
      padding-top: 5px;
      .organizers_title {
        height: 30px;
        line-height: 30px;
        color: #999;
        .tj-svg-icon {
          color: #999;
          margin-right: 5px;
          font-size: 20px;
          vertical-align: -0.2em;
        }
      }
      .organizers_list {
        .organizer_item {
          display: flex;
          padding-top: 8px;
          padding-bottom: 8px;
          border-bottom: 1px solid #ececec;
          .thumbnail {
            width: 36px;
            height: 36px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .name {
            flex: 1;
            line-height: 32px;
            margin-left: 8px;
            color: #333;
            font-size: 14px;
          }
        }
        li:last-of-type {
          border: none;
        }
      }
    }
    .backers_box {
      padding-top: 5px;
      .backers_title {
        height: 30px;
        line-height: 30px;
        color: #999;
        .tj-svg-icon {
          color: #999;
          margin-right: 5px;
          font-size: 20px;
          vertical-align: -0.2em;
        }
      }
      .backers_list {
        .backer_item {
          display: flex;
          padding-top: 8px;
          padding-bottom: 8px;
          border-bottom: 1px solid #ececec;
          .thumbnail {
            width: 36px;
            height: 36px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .name {
            flex: 1;
            line-height: 32px;
            margin-left: 8px;
            color: #333;
            font-size: 14px;
          }
        }
        li:last-of-type {
          border: none;
        }
      }
    }
    .borderTop {
      border-top: 1px solid #ececec;
    }
  }
  .activity_description_box {
    padding: 15px;
    margin: 15px;
    background-color: #fff;
    border-radius: 8px;
    .description_title {
      position: relative;
      line-height: 30px;
      padding-left: 15px;
      margin-bottom: 5px;
      color: #333;
      font-size: 18px;
      font-weight: bold;
      &::before {
        position: absolute;
        left: 0;
        top: 7px;
        display: block;
        width: 4px;
        height: 16px;
        background-color: #397ef5;
        content: "";
      }
    }
    .description_cont {
      line-height: 24px;
      text-align: justify;
      /deep/p {
        margin-bottom: 10px;
        max-width: 100%;
        img {
          display: block;
          max-width: 100%;
        }
        video {
          display: block;
          width: 100%;
        }
      }
      /deep/img {
        display: block;
        max-width: 100%;
      }
      /deep/video {
        display: block;
        width: 100%;
      }
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 50px;
    padding: 5px 5px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .operate_btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      background-color: #397ef5;
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      &.operate_btn_disabled {
        opacity: 0.7;
      }
    }
  }
  .activity_relation_box {
    position: absolute;
    right: 8px;
    bottom: 100px;
    z-index: 6;
    .related_item {
      width: 68px;
      height: 68px;
      padding: 5px 7px 10px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      span {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .raffle {
      background-image: url(~@/assets/images/activity/activity_icon_prize.png);
    }
    .live {
      background-image: url(~@/assets/images/activity/activity_icon_live.png);
    }
    .vote {
      background-image: url(~@/assets/images/activity/activity_icon_vote.png);
    }
    .my_works {
      background-image: url(~@/assets/images/activity/activity_icon_my_works.png);
    }
    .role {
      background-image: url(~@/assets/images/activity/activity_icon_role.png);
    }
  }
}
</style>